import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { Search } from 'lucide-react';

interface InspectionJourneyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
}

export function InspectionJourneyModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: InspectionJourneyModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[480px] max-w-[480px] rounded-[24px] p-6 shadow-xl'>
          <div className='flex flex-col items-start gap-8'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <Search className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Avaliação para Inspeção
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full px-6 py-0'>
              <div className='flex flex-col items-start gap-2'>
                <Text className='text-sm text-alba-gray-600'>
                  Ao seguir com a transmissão, esta proposta será submetida a um
                  processo de inspeção prévia.
                </Text>
              </div>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0 px-6'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Dialog.CloseTrigger asChild>
                  <Button variant='ghost' size='md' disabled={isLoading}>
                    Cancelar
                  </Button>
                </Dialog.CloseTrigger>
                <Button
                  variant='primary'
                  size='md'
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  Continuar
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
